module.exports = __webpack_public_path__ + "img/1686881831300-IMG_2809.jpeg.a4d22b76.webp";